/** UI strings shared by the web app and the iPhone app. */
export const ar = {
  appName: "سمرة",
  tagline: "ألعاب الجمعة، أونلاين",
  intro: "جاكارو ولودو ودومينو وكيرم وبلياردو مع ربعك، من المتصفح أو الجوال. اصنع غرفة، أرسل الكود، وابدأ.",
  play: "العب",
  signIn: "تسجيل الدخول",
  signUp: "إنشاء حساب",
  signOut: "تسجيل الخروج",
  email: "البريد الإلكتروني",
  emailOrUsername: "البريد أو اسم المستخدم",
  username: "اسم المستخدم",
  usernameHint: "3–20 حرفًا إنجليزيًا أو أرقام أو _ أو .",
  displayName: "الاسم الظاهر",
  password: "كلمة المرور",
  passwordHint: "8 أحرف على الأقل",
  newPassword: "كلمة المرور الجديدة",
  currentPassword: "كلمة المرور الحالية",
  acceptTerms: "أوافق على شروط الاستخدام وسياسة الخصوصية",
  forgot: "نسيت كلمة المرور؟",
  sendResetLink: "أرسل رابط الاستعادة",
  resetSent: "إذا كان البريد مسجلًا فستصلك رسالة خلال دقائق.",
  setPassword: "احفظ كلمة المرور",
  passwordChanged: "تم تغيير كلمة المرور. سجّل الدخول من جديد.",
  emailVerified: "تم تفعيل بريدك.",
  verifyEmailBanner: "فعّل بريدك لحماية حسابك.",
  resend: "أعد الإرسال",
  sent: "أُرسلت",
  noAccount: "ما عندك حساب؟",
  haveAccount: "عندك حساب؟",
  home: "الرئيسية",
  games: "الألعاب",
  friends: "الأصدقاء",
  store: "المتجر",
  wallet: "المحفظة",
  profile: "ملفي",
  leaderboard: "المتصدرون",
  notifications: "الإشعارات",
  settings: "الإعدادات",
  help: "المساعدة",
  privacy: "سياسة الخصوصية",
  terms: "شروط الاستخدام",
  coins: "عملة",
  balance: "الرصيد",
  level: "المستوى",
  newBadge: "جديد",
  players: "لاعبين",
  playersN: (n: number) => `${n} لاعبين`,
  quickPlay: "لعب سريع",
  vsComputer: "العب ضد الكمبيوتر",
  botLevel: { easy: "سهل", medium: "متوسط", hard: "صعب" },
  createRoom: "اصنع غرفة",
  joinByCode: "ادخل بالكود",
  roomCode: "كود الغرفة",
  join: "ادخل",
  publicRooms: "الغرف العامة",
  roomSettings: "إعدادات الغرفة",
  roomVisibility: "من يقدر ينضم",
  roomSeats: "عدد اللاعبين",
  roomSettingsSaved: "تم حفظ الإعدادات.",
  noPublicRooms: "ما فيه غرف مفتوحة لهذه اللعبة الحين. اصنع غرفة ويلحقونك.",
  public: "عامة",
  private: "خاصة",
  waiting: "بانتظار اللاعبين",
  playing: "تلعب الحين",
  host: "المشرف",
  kickPlayer: "طرد",
  transferMod: "نقل الإشراف",
  voiceMuteP: "كتم صوت اللاعب",
  voiceUnmuteP: "إلغاء كتم اللاعب",
  voiceMutedBadge: "مكتوم",
  ready: "جاهز",
  notReady: "غير جاهز",
  imReady: "أنا جاهز",
  start: "ابدأ اللعب",
  leave: "اخرج",
  invite: "ادعُ",
  inviteFriends: "ادعُ أصدقاءك",
  shareCode: "أرسل هذا الكود لربعك",
  copied: "نُسخ",
  copy: "انسخ",
  emptySeat: "مقعد فاضي",
  chat: "الدردشة",
  typeMessage: "اكتب رسالة…",
  sendMsg: "أرسل",
  yourTurn: "دورك",
  turnOf: (n: string) => `دور ${n}`,
  you: "أنت",
  waitingHost: "بانتظار المضيف يبدأ",
  needPlayers: (n: string) => `تحتاج ${n} لاعبين`,
  gameOver: "انتهت المباراة",
  winner: "الفائز",
  winners: "الفائزون",
  place: (n: number) => `المركز ${n}`,
  xpEarned: (n: number) => `+${n} خبرة`,
  rematch: "مباراة جديدة",
  backToLobby: "ارجع للعبة",
  roll: "ارمِ النرد",
  draw: "اسحب",
  pass: "مرّر",
  boneyard: "المخزن",
  left: "يسار",
  right: "يمين",
  discard: "احرق ورقة",
  mustDiscard: "ما عندك لعب — اختر ورقة تحرقها",
  pickCard: "اختر ورقة",
  pickMarble: "اختر كرة",
  pickTarget: "اختر كرة للتبديل",
  splitFirst: (n: number) => `حرّك ${n} ثم اختر الكرة الثانية`,
  exit: "أخرج كرة",
  stepsN: (n: number) => `${n} خطوات`,
  back4: "رجوع 4",
  swap: "بدّل",
  splitPickFirst: "اختر الكرة الأولى للسبع",
  splitHowMany: "كم خانة تتحرك بها هذه الكرة؟",
  splitSecond: (n: number) => `اختر الكرة الثانية لتحرك ${n} خانات`,
  splitWhole: "7 خانات بكرة واحدة",
  splitBack: "رجوع",
  jkCardPower: (r: number) => ({ 1: "إخراج · 1 · 11", 13: "إخراج · 13", 12: "12", 11: "تبديل", 10: "10", 7: "7 مقسومة", 5: "5 لأي كرة", 4: "4 للخلف" } as Record<number, string>)[r] ?? String(r),
  jkTapMarble: "اضغط على كرة مضيئة",
  jkPickDest: "اختر الوجهة على اللوحة",
  jkPickTarget: "اختر الكرة اللي تبدّل معها",
  jkExitHint: "اضغط على كرة في قاعدتك لإخراجها",
  jkSending: "جارٍ إرسال الحركة…",
  jkPlayingPartner: "كل كراتك في البيت — تلعب بكرات شريكك",
  jkDirection: "اللعب والحركة عكس عقارب الساعة",
  jkPartner: "شريكك",
  jkOffline: "غير متصل",
  jkCards: (n: number) => (n === 1 ? "ورقة واحدة" : n === 2 ? "ورقتان" : n >= 3 && n <= 10 ? `${n} أوراق` : `${n} ورقة`),
  jkDeck: (n: number) => `الكومة: ${n}`,
  jkYourCards: "أوراقك",
  jkYourTurnNow: "دورك!",
  soundOn: "شغّل صوت اللعبة",
  soundOff: "اكتم صوت اللعبة",
  ludoYouHere: "أنت",
  ludoDirection: "لونك في الزاوية السفلية اليسرى، والحركة مع عقارب الساعة",
  secondsLeft: (n: number) => `باقي ${n} ثانية`,
  moveTimeout: "ما وصل رد الخادم على حركتك. تأكد من الاتصال وحاول مرة ثانية.",
  score: "النقاط",
  team: "فريق",
  power: "القوة",
  shoot: "اضرب",
  aimHint: "اسحب من الكرة البيضاء للتصويب، ثم اضرب",
  strikerHint: "حرّك المضرب على الخط، اسحب للتصويب، ثم اضرب",
  placeCue: "اضغط على الطاولة لوضع الكرة البيضاء",
  solids: "المصمتة",
  stripes: "المخططة",
  openTable: "الطاولة مفتوحة",
  foul: "خطأ",
  queen: "الملكة",
  pairsFound: "أزواج",
  online: "متصل",
  offline: "غير متصل",
  addFriend: "أضف صديق",
  requestSent: "أُرسل الطلب",
  accept: "اقبل",
  decline: "ارفض",
  remove: "احذف",
  block: "حظر",
  unblock: "إلغاء الحظر",
  mute: "كتم",
  unmute: "إلغاء الكتم",
  report: "إبلاغ",
  reportReason: "سبب البلاغ",
  reasons: { abuse: "إساءة", cheating: "غش", spam: "إزعاج", inappropriate_name: "اسم غير لائق", other: "أخرى" },
  reportSent: "وصلنا بلاغك وسيراجعه فريق الإشراف.",
  searchPlayers: "ابحث عن لاعب",
  incoming: "طلبات واردة",
  outgoing: "طلبات مرسلة",
  noFriends: "ما عندك أصدقاء بعد. ابحث عن لاعب أو أضف من لعبت معهم.",
  stats: "الإحصاءات",
  matches: "المباريات",
  wins: "فوز",
  losses: "خسارة",
  winRate: "نسبة الفوز",
  achievements: "الإنجازات",
  noAchievements: "العب أول مباراة لتفتح أول إنجاز.",
  giftsReceived: "هدايا مستلمة",
  matchHistory: "سجل المباريات",
  noMatches: "ما لعبت مباريات بعد.",
  sendGift: "أرسل هدية",
  giftTo: (n: string) => `هدية إلى ${n}`,
  costs: (n: number) => `التكلفة ${n} عملة`,
  confirmSend: (n: number) => `أرسل مقابل ${n} عملة`,
  giftSent: "وصلت الهدية",
  giftReceived: (from: string) => `${from} أرسل لك هدية`,
  insufficient: "رصيدك لا يكفي. اشحن من المتجر.",
  topUp: "اشحن",
  buyCoins: "اشحن عملات",
  bonus: (n: number) => `+${n} هدية`,
  priceIncludesVat: "السعر شامل الضريبة",
  confirmPurchase: "تأكيد الشراء",
  youPay: "ستدفع",
  youGet: "ستحصل على",
  payNow: "ادفع",
  sandboxNotice: "بيئة اختبار: لا تُخصم أي مبالغ حقيقية.",
  simulatePaid: "محاكاة دفع ناجح",
  simulateFail: "محاكاة فشل الدفع",
  paymentUnavailable: "الدفع الإلكتروني غير مفعّل بعد في هذه النسخة. لم يُخصم أي مبلغ.",
  purchaseUnknown: "لم نتأكد من نتيجة العملية بعد. اضغط «تحقّق من الحالة» قبل أي محاولة جديدة.",
  checkStatus: "تحقّق من الحالة",
  checkingStatus: "جارٍ التحقق من العملية…",
  purchasePending: "لم تُؤكَّد العملية بعد، ولن تُخصم مرتين. اضغط «تحقّق من الحالة».",
  paymentDone: "تم الشحن",
  paymentFailed: "لم يكتمل الدفع ولم يُخصم شيء.",
  giftShop: "متجر الهدايا",
  cosmetics: "الإطارات والطاولات والمؤثرات",
  buy: "اشترِ",
  owned: "تملكه",
  equip: "استخدم",
  equipped: "مستخدم",
  history: "السجل",
  paidCoins: "مدفوعة",
  freeCoins: "مجانية",
  ledgerKinds: { topup: "شحن", topup_bonus: "مكافأة شحن", gift_purchase: "هدية", item_purchase: "شراء عنصر", refund_reversal: "استرداد", admin_adjust: "تعديل إداري", reward: "مكافأة" } as Record<string, string>,
  categories: { basic: "بسيطة", premium: "مميزة", rare: "نادرة", seasonal: "موسمية", animated: "متحركة", frame: "إطارات", avatar: "صور رمزية", table_skin: "طاولات", effect: "مؤثرات" } as Record<string, string>,
  weekly: "هذا الأسبوع",
  monthly: "هذا الشهر",
  allTime: "كل الأوقات",
  allGames: "كل الألعاب",
  points: "نقاط",
  noRanking: "ما فيه نتائج في هذه الفترة بعد.",
  markAllRead: "عيّن الكل كمقروء",
  noNotifications: "ما فيه إشعارات.",
  notif: {
    friend_request: (p: any) => `${p.displayName ?? p.username} يبي يضيفك`,
    friend_accepted: (p: any) => `${p.username} قبل طلب الصداقة`,
    room_invite: (p: any) => `${p.from?.displayName ?? ""} يدعوك للعب`,
    gift_received: (p: any) => `${p.from?.display_name ?? ""} أرسل لك ${p.name_ar ?? "هدية"}`,
    topup_success: (p: any) => `تم شحن ${p.coins} عملة`,
    coins_granted: (p: any) => `حصلت على ${p.amount} عملة مجانية`,
    dm_message: (p: any) => `رسالة جديدة من ${p.displayName ?? p.username}`,
  } as Record<string, (p: any) => string>,
  language: "اللغة",
  profileSettings: "الملف الشخصي",
  bio: "نبذة",
  avatar: "الصورة الرمزية",
  save: "احفظ",
  saved: "تم الحفظ",
  privacySettings: "الخصوصية",
  showOnline: "أظهر حالتي متصل للأصدقاء",
  allowFriendRequests: "اسمح بطلبات الصداقة",
  allowInvites: "من يقدر يدعوني للعب",
  everyone: "الكل",
  friendsOnly: "الأصدقاء فقط",
  nobody: "لا أحد",
  showStats: "أظهر إحصائياتي في ملفي",
  security: "الأمان",
  changePassword: "غيّر كلمة المرور",
  signOutEverywhere: "اخرج من كل الأجهزة",
  blockedUsers: "المحظورون",
  deleteAccount: "احذف حسابي",
  deleteWarn: "يُحذف ملفك وأصدقاؤك ورسائلك نهائيًا. الرصيد غير المستخدم لا يُسترد. للتأكيد اكتب DELETE وكلمة المرور.",
  typeDelete: "اكتب DELETE",
  loading: "لحظة…",
  retry: "حاول مرة ثانية",
  close: "إغلاق",
  cancel: "إلغاء",
  confirm: "تأكيد",
  connecting: "جارٍ الاتصال…",
  connFailed: "تعذّر الاتصال بالخادم",
  /* messages & voice calls */
  messages: "الرسائل",
  messagesTitle: "رسائلك",
  noMessages: "ما عندك رسائل بعد. ابدأ محادثة من صفحة صديقك.",
  messageTo: "رسالة إلى",
  writeMessage: "اكتب رسالة…",
  sendMessage: "أرسل",
  messageInputHint: "حتى ٣٠٠ حرف. الروابط وأرقام الهاتف ممنوعة.",
  typingNow: "يكتب الآن…",
  seenAt: "شوهد",
  loadOlder: "رسائل أقدم",
  yourMessage: "أنت",
  blockedChat: "حظرت هذا المستخدم. لن تصل الرسائل بينكما.",
  reportMessage: "إبلاغ عن الرسالة",
  reportMessageSent: "وصلنا البلاغ.",
  messageCall: "اتصال صوتي",
  realtimeOnline: "متصل",
  realtimeOffline: "غير متصل",
  callTitle: "مكالمة صوتية",
  incomingCall: "مكالمة واردة",
  declineCall: "رفض",
  acceptCall: "قبول",
  endCall: "إنهاء",
  cancelCall: "إلغاء",
  micMute: "كتم الميكروفون",
  micUnmute: "تشغيل الميكروفون",
  micOn: "الميكروفون يعمل",
  micOff: "الميكروفون مكتوم",
  peerMuted: "الطرف الآخر مكتوم",
  callRinging: "يرنّ…",
  callCalling: "جارٍ الاتصال…",
  callConnecting: "جارٍ الربط…",
  callActive: "جارية",
  callReconnecting: "إعادة الاتصال…",
  callEnded: "انتهت المكالمة",
  callDeclined: "تم رفض المكالمة",
  callMissed: "لم يُجَب على المكالمة",
  callCancelled: "ألغى المتصل المكالمة",
  callFailed: "فشلت المكالمة",
  callNotRecorded: "المكالمة غير مسجّلة ولا يُحفظ صوتها.",
  micPermissionHelp: "اسمح للموقع باستخدام الميكروفون من إعدادات المتصفح ثم حاول مرة أخرى.",
  messagesAndCalls: "الرسائل والمكالمات",
  allowDirect: "من يحق له مراسلتي والاتصال بي",
  allowDirectHint: "أصدقاؤك فقط مفضّل لتقليل الإزعاج.",
  dmNotifications: "إشعار عند وصول رسالة جديدة",
  unreadBadge: "غير مقروءة",
  announcements: "الأخبار",
  seeAll: "الكل",
  friendsOnline: "أصدقاء متصلون",
  invitations: "دعوات اللعب",
  admin: "لوحة الإدارة",
  phrases: { hi: "هلا والله", gg: "لعب حلو", wow: "يا سلام!", hurry: "يلا بسرعة", thanks: "مشكور", oops: "أفا!", again: "نعيدها؟", luck: "بالتوفيق" } as Record<string, string>,
  game: { jackaroo: "جاكارو", ludo: "لودو", domino: "دومينو", carrom: "كيرم", billiards: "بلياردو", memory: "ذاكرة" } as Record<string, string>,
  gameBlurb: {
    jackaroo: "ورق وكرات، فريقين ضد بعض",
    ludo: "النرد يقرر، والذكاء يكمّل",
    domino: "قفّلها قبلهم",
    carrom: "ضربة وحدة تكفي",
    billiards: "بلياردو الكرة 8",
    memory: "تذكّر وين الأزواج",
  } as Record<string, string>,
  errors: {
    request_timeout: "انتهت مهلة الاتصال بالخادم. تحقّق من الحالة قبل إعادة المحاولة.",
    network_error: "تعذّر الاتصال بالخادم. تحقّق من الإنترنت.",
    invalid_credentials: "البيانات غير صحيحة.",
    email_taken: "هذا البريد مسجّل من قبل.",
    username_taken: "اسم المستخدم مأخوذ.",
    validation_failed: "راجع الحقول المظللة.",
    rate_limited: "محاولات كثيرة. انتظر قليلًا وحاول.",
    account_banned: "الحساب موقوف.",
    room_not_found: "ما لقينا الغرفة. تأكد من الكود.",
    not_in_room: "ما أنت داخل هذي الغرفة. ادخل بالكود أو اطلب دعوة.",
    room_full: "الغرفة ممتلئة.",
    too_many_players: "عدد اللاعبين الحاليين أكبر من هذا الرقم.",
    bad_player_count: "عدد اللاعبين غير مدعوم لهذه اللعبة.",
    voice_full: "الصوت ممتلئ.",
    voice_muted_by_moderator: "كتمك المشرف في الصوت، ولا يمكنك تشغيل الميكروفون.",
    not_in_voice: "لست في الصوت الجماعي.",
    peer_not_in_voice: "هذا اللاعب ليس في الصوت الجماعي.",
    bad_sid: "جلسة الصوت غير صالحة.",
    removed_from_room: "أُزلت من الغرفة.",
    room_in_game: "المباراة بدأت في هذه الغرفة.",
    private_room: "غرفة خاصة: تحتاج الكود أو دعوة.",
    players_not_ready: "بعض اللاعبين ما جهزوا.",
    need_players: "عدد اللاعبين غير مناسب لهذه اللعبة.",
    host_only: "المضيف فقط يقدر يبدأ.",
    insufficient_balance: "رصيدك لا يكفي. اشحن من المتجر.",
    price_changed: "تغيّر السعر. راجع السعر الجديد.",
    blocked: "ما تقدر تتفاعل مع هذا المستخدم.",
    not_your_turn: "مو دورك.",
    links_not_allowed: "الروابط ممنوعة في الدردشة.",
    contact_details_not_allowed: "لا تشارك أرقام التواصل في الدردشة.",
    chat_rate_limited: "تمهّل في الرسائل.",
    direct_not_allowed: "هذا المستخدم لا يستقبل رسائل أو مكالمات منك.",
    duplicate_message: "أرسلت هذه الرسالة للتو. غيّر النص أو انتظر.",
    cannot_message_self: "لا يمكنك مراسلة نفسك.",
    user_offline: "هذا المستخدم غير متصل الآن.",
    busy: "هذا المستخدم في مكالمة أخرى.",
    already_in_call: "أنت في مكالمة بالفعل.",
    call_not_found: "المكالمة لم تعد متاحة.",
    call_not_ringing: "المكالمة لم تعد ترنّ.",
    call_not_active: "المكالمة لم تبدأ بعد.",
    call_exists: "المكالمة موجودة بالفعل.",
    bad_signal: "فشل إرسال بيانات المكالمة.",
    bad_call: "معرّف المكالمة غير صالح.",
    bad_user: "المستخدم غير صالح.",
    cannot_call_self: "لا يمكنك الاتصال بنفسك.",
    call_check_failed: "تعذّر التحقق من المكالمة. حاول مرة أخرى.",
    mic_permission_denied: "لم يُسمح للموقع باستخدام الميكروفون.",
    no_microphone: "لم يُعثر على ميكروفون.",
    mic_unavailable: "تعذّر تشغيل الميكروفون.",
    requires_https: "المكالمات الصوتية تحتاج اتصالًا آمنًا (HTTPS).",
    unsupported_browser: "متصفحك لا يدعم المكالمات الصوتية.",
    invites_not_allowed: "هذا اللاعب لا يستقبل دعوات منك.",
    not_accepting_requests: "هذا اللاعب لا يستقبل طلبات صداقة.",
    already_owned: "تملك هذا العنصر.",
    invalid_or_expired_token: "الرابط منتهي أو مستخدم.",
    game_unavailable: "اللعبة غير متاحة حاليًا.",
    unauthenticated: "سجّل الدخول أولًا.",
    session_expired: "انتهت الجلسة. سجّل الدخول من جديد.",
    must_roll: "ارمِ النرد أولًا.",
    must_move: "حرّك كرة أولًا.",
    illegal_token: "هذه الحركة غير مسموحة.",
    must_play: "عندك قطعة تنلعب — العبها.",
    must_draw: "اسحب من المخزن.",
    does_not_match: "القطعة لا تطابق الطرف.",
    must_play_a_card: "عندك ورقة تنلعب — ما تقدر تحرق.",
    path_blocked: "الطريق مسدود بكرة محمية.",
    overshoot: "الرقم أكبر من الطريق للبيت.",
    home_blocked: "البيت مسدود.",
    own_marble: "ما تقدر تنزل على كرتك.",
    protected: "الكرة محمية في مكان انطلاقها.",
    start_occupied: "مكان الانطلاق مشغول بكرتك.",
    already_open: "الورقة مكشوفة.",
    striker_overlaps_coin: "المضرب فوق قرص. حرّكه.",
    place_cue_ball_first: "ضع الكرة البيضاء أولًا.",
    behind_head_string: "ضع الكرة خلف الخط في أول ضربة.",
    spot_taken: "المكان مشغول.",
    game_over: "انتهت المباراة.",
  } as Record<string, string>,
  genericError: "صار خطأ. حاول مرة ثانية.",
  footer: "سمرة منتج من TechCore",
  voiceTitle: "الصوت الجماعي",
  voiceHint: "يسمع اللاعبون في الغرفة بعضهم فقط. الميكروفون مغلق حتى تفعّله.",
  voiceJoin: "انضم للصوت",
  voiceLeave: "اخرج من الصوت",
  voiceMicOn: "شغّل الميكروفون",
  voiceMicOff: "أغلق الميكروفون",
  voiceMutedByMod: "كتمه المشرف",
  voiceSpeaking: "يتحدث",
  voiceConnecting: "جارٍ الاتصال",
  voiceConnected: "متصل",
  voiceReconnecting: "يعيد الاتصال",
  voiceFailed: "تعذّر الاتصال",
  voiceEmpty: "لا أحد في الصوت الآن.",
  voiceListening: "تسمع الآخرين، ولا يسمعك أحد حتى تشغّل الميكروفون.",
  voiceMicOpen: "الميكروفون يعمل",
  voiceMicClosed: "الميكروفون مغلق",
  voiceFull: (max: number) => `الصوت ممتلئ، الحد ${max} لاعبين.`,
  voiceNoMic: "لا يوجد ميكروفون متاح على هذا الجهاز.",
  voiceRemoved: "أُزلت من هذه الغرفة.",
  voiceMicSettings: "اسمح للموقع باستخدام الميكروفون من إعدادات المتصفح، ثم حاول مرة أخرى.",
  voiceBadge: "مشرف الغرفة",
};

export type Dict = typeof ar;

export const en: Dict = {
  appName: "Samra",
  tagline: "Game night, online",
  intro: "Jackaroo, Ludo, Dominoes, Carrom and Pool with your friends — in the browser or on your phone. Make a room, share the code, play.",
  play: "Play",
  signIn: "Sign in",
  signUp: "Create account",
  signOut: "Sign out",
  email: "Email",
  emailOrUsername: "Email or username",
  username: "Username",
  usernameHint: "3–20 letters, numbers, _ or .",
  displayName: "Display name",
  password: "Password",
  passwordHint: "At least 8 characters",
  newPassword: "New password",
  currentPassword: "Current password",
  acceptTerms: "I agree to the Terms and Privacy Policy",
  forgot: "Forgot password?",
  sendResetLink: "Send reset link",
  resetSent: "If that email is registered, a message is on its way.",
  setPassword: "Save password",
  passwordChanged: "Password changed. Sign in again.",
  emailVerified: "Your email is verified.",
  verifyEmailBanner: "Verify your email to protect your account.",
  resend: "Resend",
  sent: "Sent",
  noAccount: "New to Samra?",
  haveAccount: "Already have an account?",
  home: "Home",
  games: "Games",
  friends: "Friends",
  store: "Store",
  wallet: "Wallet",
  profile: "Profile",
  leaderboard: "Leaderboard",
  notifications: "Notifications",
  settings: "Settings",
  help: "Help",
  privacy: "Privacy policy",
  terms: "Terms of use",
  coins: "coins",
  balance: "Balance",
  level: "Level",
  newBadge: "New",
  players: "Players",
  playersN: (n) => `${n} Players`,
  quickPlay: "Quick play",
  vsComputer: "Play vs computer",
  botLevel: { easy: "Easy", medium: "Medium", hard: "Hard" },
  createRoom: "Create room",
  joinByCode: "Join with code",
  roomCode: "Room code",
  join: "Join",
  publicRooms: "Public rooms",
  roomSettings: "Room settings",
  roomVisibility: "Who can join",
  roomSeats: "Players",
  roomSettingsSaved: "Settings saved.",
  noPublicRooms: "No open rooms for this game right now. Create one and others will join.",
  public: "Public",
  private: "Private",
  waiting: "Waiting for players",
  playing: "In a match",
  host: "Moderator",
  kickPlayer: "Kick",
  transferMod: "Make moderator",
  voiceMuteP: "Mute player voice",
  voiceUnmuteP: "Unmute player voice",
  voiceMutedBadge: "Muted",
  ready: "Ready",
  notReady: "Not ready",
  imReady: "I'm ready",
  start: "Start match",
  leave: "Leave",
  invite: "Invite",
  inviteFriends: "Invite friends",
  shareCode: "Send this code to your friends",
  copied: "Copied",
  copy: "Copy",
  emptySeat: "Empty seat",
  chat: "Chat",
  typeMessage: "Type a message…",
  sendMsg: "Send",
  yourTurn: "Your turn",
  turnOf: (n) => `${n}'s turn`,
  you: "You",
  waitingHost: "Waiting for the host to start",
  needPlayers: (n) => `Needs ${n} players`,
  gameOver: "Match over",
  winner: "Winner",
  winners: "Winners",
  place: (n) => `Place ${n}`,
  xpEarned: (n) => `+${n} XP`,
  rematch: "Rematch",
  backToLobby: "Back to game",
  roll: "Roll",
  draw: "Draw",
  pass: "Pass",
  boneyard: "Boneyard",
  left: "Left",
  right: "Right",
  discard: "Burn a card",
  mustDiscard: "No moves — pick a card to burn",
  pickCard: "Pick a card",
  pickMarble: "Pick a marble",
  pickTarget: "Pick a marble to swap with",
  splitFirst: (n) => `Move ${n}, then pick the second marble`,
  exit: "Bring out",
  stepsN: (n) => `${n} steps`,
  back4: "Back 4",
  swap: "Swap",
  splitPickFirst: "Pick the first marble for the 7",
  splitHowMany: "How many steps for this marble?",
  splitSecond: (n: number) => `Pick the second marble to move ${n} steps`,
  splitWhole: "All 7 with one marble",
  splitBack: "Back",
  jkCardPower: (r: number) => ({ 1: "Out · 1 · 11", 13: "Out · 13", 12: "12", 11: "Swap", 10: "10", 7: "Split 7", 5: "5, any marble", 4: "Back 4" } as Record<number, string>)[r] ?? String(r),
  jkTapMarble: "Tap a glowing marble",
  jkPickDest: "Pick where it goes on the board",
  jkPickTarget: "Pick the marble to swap with",
  jkExitHint: "Tap a marble in your base to bring it out",
  jkSending: "Sending your move…",
  jkPlayingPartner: "All your marbles are home — you play your partner's",
  jkDirection: "play and movement run counter-clockwise",
  jkPartner: "Partner",
  jkOffline: "Offline",
  jkCards: (n: number) => (n === 1 ? "1 card" : `${n} cards`),
  jkDeck: (n: number) => `Deck: ${n}`,
  jkYourCards: "Your cards",
  jkYourTurnNow: "Your turn!",
  soundOn: "Turn game sound on",
  soundOff: "Mute game sound",
  ludoYouHere: "You",
  ludoDirection: "your colour is bottom-left; tokens move clockwise",
  secondsLeft: (n: number) => `${n} seconds left`,
  moveTimeout: "No reply from the server for your move. Check your connection and try again.",
  score: "Score",
  team: "Team",
  power: "Power",
  shoot: "Shoot",
  aimHint: "Drag from the cue ball to aim, then shoot",
  strikerHint: "Slide the striker on the line, drag to aim, then shoot",
  placeCue: "Tap the table to place the cue ball",
  solids: "Solids",
  stripes: "Stripes",
  openTable: "Open table",
  foul: "Foul",
  queen: "Queen",
  pairsFound: "pairs",
  online: "Online",
  offline: "Offline",
  addFriend: "Add friend",
  requestSent: "Request sent",
  accept: "Accept",
  decline: "Decline",
  remove: "Remove",
  block: "Block",
  unblock: "Unblock",
  mute: "Mute",
  unmute: "Unmute",
  report: "Report",
  reportReason: "Reason",
  reasons: { abuse: "Abuse", cheating: "Cheating", spam: "Spam", inappropriate_name: "Inappropriate name", other: "Other" },
  reportSent: "Thanks. Moderators will review your report.",
  searchPlayers: "Search players",
  incoming: "Requests",
  outgoing: "Sent requests",
  noFriends: "No friends yet. Search for a player or add someone you played with.",
  stats: "Stats",
  matches: "Matches",
  wins: "Wins",
  losses: "Losses",
  winRate: "Win rate",
  achievements: "Achievements",
  noAchievements: "Play your first match to unlock your first achievement.",
  giftsReceived: "Gifts received",
  matchHistory: "Match history",
  noMatches: "No matches yet.",
  sendGift: "Send a gift",
  giftTo: (n) => `Gift for ${n}`,
  costs: (n) => `Costs ${n} coins`,
  confirmSend: (n) => `Send for ${n} coins`,
  giftSent: "Gift sent",
  giftReceived: (from) => `${from} sent you a gift`,
  insufficient: "Not enough coins. Top up in the store.",
  topUp: "Top up",
  buyCoins: "Buy coins",
  bonus: (n) => `+${n} bonus`,
  priceIncludesVat: "Price includes VAT",
  confirmPurchase: "Confirm purchase",
  youPay: "You pay",
  youGet: "You get",
  payNow: "Pay",
  sandboxNotice: "Test mode: no real money is charged.",
  simulatePaid: "Simulate successful payment",
  simulateFail: "Simulate failed payment",
  paymentUnavailable: "Online payment is not enabled in this build yet. Nothing was charged.",
  purchaseUnknown: "We could not confirm the result yet. Tap \"Check status\" before trying again.",
  checkStatus: "Check status",
  checkingStatus: "Checking the purchase…",
  purchasePending: "The purchase is not confirmed yet and will not be charged twice. Tap \"Check status\".",
  paymentDone: "Coins added",
  paymentFailed: "Payment didn't complete. Nothing was charged.",
  giftShop: "Gift shop",
  cosmetics: "Frames, tables and effects",
  buy: "Buy",
  owned: "Owned",
  equip: "Use",
  equipped: "In use",
  history: "History",
  paidCoins: "Paid",
  freeCoins: "Free",
  ledgerKinds: { topup: "Top-up", topup_bonus: "Top-up bonus", gift_purchase: "Gift", item_purchase: "Item", refund_reversal: "Refund", admin_adjust: "Adjustment", reward: "Reward" },
  categories: { basic: "Basic", premium: "Premium", rare: "Rare", seasonal: "Seasonal", animated: "Animated", frame: "Frames", avatar: "Avatars", table_skin: "Tables", effect: "Effects" },
  weekly: "This week",
  monthly: "This month",
  allTime: "All time",
  allGames: "All games",
  points: "Points",
  noRanking: "No results for this period yet.",
  markAllRead: "Mark all as read",
  noNotifications: "No notifications.",
  notif: {
    friend_request: (p) => `${p.displayName ?? p.username} wants to be friends`,
    friend_accepted: (p) => `${p.username} accepted your request`,
    room_invite: (p) => `${p.from?.displayName ?? ""} invited you to play`,
    gift_received: (p) => `${p.from?.display_name ?? ""} sent you ${p.name_en ?? "a gift"}`,
    topup_success: (p) => `${p.coins} coins added`,
    coins_granted: (p) => `You received ${p.amount} free coins`,
    dm_message: (p) => `New message from ${p.displayName ?? p.username}`,
  },
  language: "Language",
  profileSettings: "Profile",
  bio: "Bio",
  avatar: "Avatar",
  save: "Save",
  saved: "Saved",
  privacySettings: "Privacy",
  showOnline: "Show friends when I'm online",
  allowFriendRequests: "Allow friend requests",
  allowInvites: "Who can invite me to play",
  everyone: "Everyone",
  friendsOnly: "Friends only",
  nobody: "Nobody",
  showStats: "Show my stats on my profile",
  security: "Security",
  changePassword: "Change password",
  signOutEverywhere: "Sign out of all devices",
  blockedUsers: "Blocked players",
  deleteAccount: "Delete my account",
  deleteWarn: "Your profile, friends and messages are permanently deleted. Unused coins are not refunded. Type DELETE and your password to confirm.",
  typeDelete: "Type DELETE",
  loading: "Loading…",
  retry: "Try again",
  close: "Close",
  cancel: "Cancel",
  confirm: "Confirm",
  connecting: "Connecting…",
  connFailed: "Couldn't reach the server",
  /* messages & voice calls */
  messages: "Messages",
  messagesTitle: "Your messages",
  noMessages: "No messages yet. Start a chat from a friend's profile.",
  messageTo: "Message",
  writeMessage: "Write a message…",
  sendMessage: "Send",
  messageInputHint: "Up to 300 characters. Links and phone numbers are not allowed.",
  typingNow: "typing…",
  seenAt: "Seen",
  loadOlder: "Older messages",
  yourMessage: "You",
  blockedChat: "You blocked this user. Messages between you are not delivered.",
  reportMessage: "Report message",
  reportMessageSent: "Report received.",
  messageCall: "Voice call",
  realtimeOnline: "Online",
  realtimeOffline: "Offline",
  callTitle: "Voice call",
  incomingCall: "Incoming call",
  declineCall: "Decline",
  acceptCall: "Accept",
  endCall: "End",
  cancelCall: "Cancel",
  micMute: "Mute microphone",
  micUnmute: "Unmute microphone",
  micOn: "Microphone on",
  micOff: "Microphone muted",
  peerMuted: "The other person is muted",
  callRinging: "Ringing…",
  callCalling: "Calling…",
  callConnecting: "Connecting…",
  callActive: "In call",
  callReconnecting: "Reconnecting…",
  callEnded: "Call ended",
  callDeclined: "The call was declined",
  callMissed: "No answer",
  callCancelled: "The caller hung up",
  callFailed: "The call failed",
  callNotRecorded: "This call is not recorded and its audio is not stored.",
  micPermissionHelp: "Allow the site to use your microphone in browser settings, then try again.",
  messagesAndCalls: "Messages and calls",
  allowDirect: "Who may message or call me",
  allowDirectHint: "Friends only is the default to reduce unwanted contact.",
  dmNotifications: "Notify me when a new message arrives",
  unreadBadge: "unread",
  announcements: "News",
  seeAll: "See all",
  friendsOnline: "Friends online",
  invitations: "Invitations",
  admin: "Admin",
  phrases: { hi: "Hey there", gg: "Good game", wow: "Wow!", hurry: "Hurry up", thanks: "Thanks", oops: "Oops!", again: "Rematch?", luck: "Good luck" },
  game: { jackaroo: "Jackaroo", ludo: "Ludo", domino: "Dominoes", carrom: "Carrom", billiards: "8-Ball Pool", memory: "Memory" },
  gameBlurb: {
    jackaroo: "Cards and marbles, two teams",
    ludo: "Dice decide, strategy finishes",
    domino: "Block them before they block you",
    carrom: "One clean strike",
    billiards: "Classic 8-ball",
    memory: "Remember where the pairs are",
  },
  errors: {
    request_timeout: "The server took too long to answer. Check the status before trying again.",
    network_error: "Could not reach the server. Check your connection.",
    invalid_credentials: "Those details don't match.",
    email_taken: "That email already has an account.",
    username_taken: "That username is taken.",
    validation_failed: "Check the highlighted fields.",
    rate_limited: "Too many attempts. Wait a moment and try again.",
    account_banned: "This account is suspended.",
    room_not_found: "Room not found. Check the code.",
    not_in_room: "You are not in this room. Join with the code or ask for an invite.",
    room_full: "The room is full.",
    too_many_players: "More players are seated than this number allows.",
    bad_player_count: "That player count is not supported for this game.",
    voice_full: "Voice is full.",
    voice_muted_by_moderator: "A moderator muted you in voice, so you cannot turn your mic on.",
    not_in_voice: "You are not in group voice.",
    peer_not_in_voice: "That player is not in group voice.",
    bad_sid: "Invalid voice session.",
    removed_from_room: "You were removed from this room.",
    room_in_game: "A match has already started in this room.",
    private_room: "Private room: you need the code or an invite.",
    players_not_ready: "Some players aren't ready.",
    need_players: "Wrong number of players for this game.",
    host_only: "Only the host can start.",
    insufficient_balance: "Not enough coins. Top up in the store.",
    price_changed: "The price changed. Check the new price.",
    blocked: "You can't interact with this player.",
    not_your_turn: "Not your turn.",
    links_not_allowed: "Links aren't allowed in chat.",
    contact_details_not_allowed: "Don't share contact numbers in chat.",
    chat_rate_limited: "Slow down a little.",
    direct_not_allowed: "This person doesn't accept messages or calls from you.",
    duplicate_message: "You just sent that. Change the text or wait.",
    cannot_message_self: "You can't message yourself.",
    user_offline: "This person is offline right now.",
    busy: "This person is already on another call.",
    already_in_call: "You are already on a call.",
    call_not_found: "That call is no longer available.",
    call_not_ringing: "That call is no longer ringing.",
    call_not_active: "The call hasn't started yet.",
    call_exists: "That call already exists.",
    bad_signal: "Call data could not be sent.",
    bad_call: "Invalid call reference.",
    bad_user: "Invalid user.",
    cannot_call_self: "You can't call yourself.",
    call_check_failed: "Couldn't verify the call. Try again.",
    mic_permission_denied: "The site isn't allowed to use your microphone.",
    no_microphone: "No microphone was found.",
    mic_unavailable: "Couldn't start the microphone.",
    requires_https: "Voice calls need a secure connection (HTTPS).",
    unsupported_browser: "Your browser doesn't support voice calls.",
    invites_not_allowed: "This player doesn't accept invites from you.",
    not_accepting_requests: "This player isn't accepting friend requests.",
    already_owned: "You already own this.",
    invalid_or_expired_token: "This link has expired or was already used.",
    game_unavailable: "This game isn't available right now.",
    unauthenticated: "Sign in first.",
    session_expired: "Your session ended. Sign in again.",
    must_roll: "Roll first.",
    must_move: "Move a token first.",
    illegal_token: "That move isn't allowed.",
    must_play: "You have a playable tile — play it.",
    must_draw: "Draw from the boneyard.",
    does_not_match: "That tile doesn't match the end.",
    must_play_a_card: "You have a playable card — you can't burn.",
    path_blocked: "A protected marble blocks the way.",
    overshoot: "Too far to fit in your home row.",
    home_blocked: "Your home row is blocked.",
    own_marble: "You can't land on your own marble.",
    protected: "That marble is protected on its start square.",
    start_occupied: "Your start square is occupied.",
    already_open: "That card is already open.",
    striker_overlaps_coin: "The striker is on a coin. Move it.",
    place_cue_ball_first: "Place the cue ball first.",
    behind_head_string: "Place the cue ball behind the line for the break.",
    spot_taken: "That spot is taken.",
    game_over: "The match is over.",
  },
  genericError: "Something went wrong. Try again.",
  footer: "Samra is a TechCore product",
  voiceTitle: "Group voice",
  voiceHint: "Only players in this room can hear each other. Your microphone stays off until you turn it on.",
  voiceJoin: "Join voice",
  voiceLeave: "Leave voice",
  voiceMicOn: "Turn mic on",
  voiceMicOff: "Turn mic off",
  voiceMutedByMod: "Muted by moderator",
  voiceSpeaking: "Speaking",
  voiceConnecting: "Connecting",
  voiceConnected: "Connected",
  voiceReconnecting: "Reconnecting",
  voiceFailed: "Connection failed",
  voiceEmpty: "Nobody is in voice yet.",
  voiceListening: "You can hear the others; they cannot hear you until you turn your mic on.",
  voiceMicOpen: "Microphone on",
  voiceMicClosed: "Microphone off",
  voiceFull: (max: number) => `Voice is full: the limit is ${max} players.`,
  voiceNoMic: "No microphone is available on this device.",
  voiceRemoved: "You were removed from this room.",
  voiceMicSettings: "Allow the site to use your microphone in browser settings, then try again.",
  voiceBadge: "Room moderator",
};

